import { ownerChatInputEl } from './dom.js';

const OWNER_CHAT_INPUT_MAX_HEIGHT_PX = 132;

export function syncOwnerChatInputHeight(): void {
  const el = ownerChatInputEl;
  if (!el) return;
  el.style.height = 'auto';
  const next = Math.min(el.scrollHeight, OWNER_CHAT_INPUT_MAX_HEIGHT_PX);
  el.style.height = Math.max(44, next) + 'px';
}

export function bindOwnerChatComposerInput(): void {
  if (!ownerChatInputEl) return;
  ownerChatInputEl.addEventListener('input', function () {
    syncOwnerChatInputHeight();
  });
  syncOwnerChatInputHeight();
}
